<template lang="pug">
  .wrap

    template(v-if='!showPlaceholder')
      page-title Your Products

      list-header(:on-search='search')
        router-link(slot='action' :to="{ name: 'brapp:sales:productCreate' }")
          el-button(type="primary") Add New product

      el-table(:data="list.results" empty-text="No entries" v-loading='loading' @sort-change='changeSort')
        el-table-column(width="100" align='center' label='Status' class-name='status-cell')
          template(slot-scope="scope")
            icon.status-icon(v-if='scope.row.status === "published"' name='check-circle' color='#7fc4be' :scale='1.5')
            icon.status-icon(v-if='scope.row.status === "draft"' name='times-circle' color='#dd6e69' :scale='1.5')

        el-table-column(label="Categories" width="250")
          template(slot-scope="scope")
            el-tag(type="primary" v-for='categoryAssignment in scope.row.categoryAssignments' :key='categoryAssignment.id')
              | {{ categoryAssignment.category.name }}

        el-table-column(label="Product" sortable prop='name' class-name='title-cell' min-width="250")
          template(slot-scope="scope")
            div(@click='navigateToEdit(scope.row.id)')
              | {{ scope.row.name }}

        el-table-column(label="Price" sortable prop='price' width='170')
          template(slot-scope="scope")
            | {{ formatCompanyCurrency(scope.row.price) }}

        el-table-column(width='120' align='center')
          template(slot-scope="scope")
            el-button.table-button(size='small' @click='navigateToEdit(scope.row.id)')
              icon.report-icon(name='edit' color='#999')
              | Edit

      .pages
        el-pagination(layout="prev, pager, next" @current-change='changePage' :total="list.count" :page-size='pageSize')

    .empty(v-else)
      sales-empty-state(:cta-route="{ name: 'brapp:sales:productCreate' }")

</template>

<script>
import { mapActions } from "vuex";
import PageTitle from "@/shared/components/layout/PageTitle";
import ListHeader from "@/shared/components/ListHeader";
import FormattingMixin from "@/shared/mixins/Formatting";
import salesEmptyState from "../../salesEmptyState";

export default {
  components: { PageTitle, ListHeader, salesEmptyState },
  mixins: [FormattingMixin],
  data() {
    return {
      loading: true,
      pageSize: 20,
      searchParams: null,
      list: {
        retults: [],
        count: 0
      }
    };
  },
  computed: {
    showPlaceholder() {
      return !this.loading && !this.searchParams && !this.list.count;
    }
  },
  methods: {
    ...mapActions({
      fetchProducts: "products/fetchProducts"
    }),
    loadList({ params } = {}) {
      const mergedParams = {
        pageSize: this.pageSize,
        ...params
      };
      this.loading = true;
      this.fetchProducts({ params: mergedParams }).then(data => {
        this.loading = false;
        this.list = data;
      });
    },
    search(q) {
      if (q) {
        this.searchParams = { q };
      } else {
        this.searchParams = null;
      }
      this.loadList({ params: { q } });
    },
    navigateToEdit(productId) {
      this.$router.push({
        name: "brapp:sales:productEdit",
        params: { productId }
      });
    },
    changeSort({ prop, order }) {
      if (!order) {
        this.loadList();
        return;
      }
      const sortVal = (order === "ascending" ? "" : "-") + prop;
      this.loading = true;
      this.loadList({ params: { sort: sortVal } });
    },
    changePage(page) {
      this.loadList({ params: { page } });
    }
  },
  created() {
    this.loadList();
  }
};
</script>

<style scoped lang="scss">
.emptystate {
  width: 100%;
}

.message {
  font-size: 13px;
  color: #666;
  line-height: 20px;
}

.wrap {
  :global(td.stat-cell .cell) {
    font-size: 16px;
    line-height: 20px;
    padding: 20px 0;
  }

  :global(td .cell) {
    line-height: 24px;
  }

  :global(.status-cell .cell) {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  :global(td.title-cell) {
    font-size: 16px;
    cursor: pointer;
  }
}

.pages {
  margin-top: 30px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 20px;
  color: #999;
  border: 1px solid #ddd;
  border-radius: 2px;
  background: white;
  padding: 80px 0;
  flex-direction: column;
}

.placeholder-actions {
  margin-top: 30px;
}

.emptystate {
  width: 100%;
}
</style>
